"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_1 = require("@inertiajs/inertia");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_aria_menubutton_1 = require("react-aria-menubutton");
var MoreButton_1 = __importStar(require("../MoreButton"));
require("./Dropdown.scss");
var DropdownType;
(function (DropdownType) {
    DropdownType["DEFAULT"] = "default";
    DropdownType["MORE"] = "more";
    DropdownType["MORE_SMALL"] = "more_small";
    DropdownType["THROUGH"] = "through";
})(DropdownType = exports.DropdownType || (exports.DropdownType = {}));
function DropdownTrigger(_a) {
    var type = _a.type, text = _a.text;
    switch (type) {
        case 'through':
            return react_1.default.createElement(react_aria_menubutton_1.Button, { className: "dropdown__button dropdown__button--through" }, text);
        case 'more_small':
            return (react_1.default.createElement(react_aria_menubutton_1.Button, { className: "dropdown__button dropdown__button--through" },
                react_1.default.createElement(MoreButton_1.MoreButtonChevron, null)));
        case 'more':
            return (react_1.default.createElement(react_aria_menubutton_1.Button, { className: "dropdown__button dropdown__button--through" },
                react_1.default.createElement(MoreButton_1.default, null)));
        default:
            return react_1.default.createElement(react_aria_menubutton_1.Button, { className: "button" }, text);
    }
}
var Dropdown = function (props) {
    var className = props.className, dusk = props.dusk, _a = props.items, items = _a === void 0 ? [] : _a, onSelect = props.onSelect, _b = props.position, position = _b === void 0 ? 'left' : _b, text = props.text, _c = props.type, type = _c === void 0 ? DropdownType.DEFAULT : _c, width = props.width;
    return (react_1.default.createElement(react_aria_menubutton_1.Wrapper, { className: classnames_1.default('dropdown', {
            'dropdown--right': position === 'right',
            'dropdown--left': position === 'left',
            'py-2 h-full': type === DropdownType.MORE,
        }, className), onSelection: onSelect, "data-dusk": dusk },
        react_1.default.createElement(DropdownTrigger, { text: text, type: type || DropdownType.DEFAULT }),
        react_1.default.createElement(react_aria_menubutton_1.Menu, { className: "dropdown__menu " + (width ? "dropdown__menu-w-" + width : '') },
            react_1.default.createElement(react_1.default.Fragment, null, items.length > 0 && (react_1.default.createElement("ul", null, items.map(function (_a, index) {
                var _b = _a.dusk, dusk = _b === void 0 ? null : _b, _c = _a.tag, tag = _c === void 0 ? 'span' : _c, label = _a.label, _d = _a.href, href = _d === void 0 ? undefined : _d, _e = _a.inertia, inertia = _e === void 0 ? true : _e, _f = _a.method, method = _f === void 0 ? 'visit' : _f, onClick = _a.onClick, _g = _a.pending, pending = _g === void 0 ? false : _g, _h = _a.divideBefore, divideBefore = _h === void 0 ? false : _h, _j = _a.requestData, requestData = _j === void 0 ? {} : _j, args = _a.args;
                return (react_1.default.createElement(react_1.default.Fragment, { key: "ddli-" + index },
                    divideBefore && react_1.default.createElement("li", { className: "dropdown__menu-divider" }),
                    react_1.default.createElement("li", { "data-dusk": dusk },
                        react_1.default.createElement(react_aria_menubutton_1.MenuItem, __assign({ tag: href ? 'a' : tag, className: "dropdown__item", href: href, disabled: pending, onClick: function (e) {
                                if (onClick) {
                                    return onClick(e);
                                }
                                if (inertia && href) {
                                    e.preventDefault();
                                    if (method === 'get') {
                                        inertia_1.Inertia.visit(href, requestData);
                                    }
                                    else {
                                        inertia_1.Inertia[method](href, requestData, {
                                            preserveScroll: true,
                                        });
                                    }
                                }
                            } }, args), label))));
            })))))));
};
exports.default = Dropdown;
//# sourceMappingURL=index.js.map